import React from 'react';
import { Sparkles } from 'lucide-react';
import { Button } from '@roger/ui-components';
import {
  REVIEW_CONVERSIONS_LABEL,
  convertedCountCopy,
} from './importedChartLineCopy';

/**
 * The quiet way back into the Importer tool once nothing is left raw.
 *
 * Lines the import coded on a certain match are on the chart
 * already, so there is nothing to warn about: no amber, no alert icon. But the
 * conversion must stay visible and revertible, so the tool stays one click
 * away while any conversion exists.
 */
const ImportedConversionsNote: React.FC<{
  convertedCount: number;
  kind: 'medication' | 'allergy';
  /** Absent when the viewer lacks the reconcile permission. */
  onOpenImporter?: () => void;
}> = ({ convertedCount, kind, onOpenImporter }) => {
  if (convertedCount === 0) {
    return null;
  }
  return (
    <div
      className='mb-4 flex flex-col gap-2 rounded-md border bg-muted/30 p-3 sm:flex-row sm:items-center sm:justify-between'
      data-testid='imported-conversions-note'
    >
      <div className='flex gap-2'>
        <Sparkles className='mt-0.5 h-4 w-4 shrink-0 text-muted-foreground' />
        <p className='text-sm text-muted-foreground'>
          {convertedCountCopy(convertedCount, kind)}
        </p>
      </div>
      {onOpenImporter && (
        <Button
          size='sm'
          variant='outline'
          className='shrink-0 self-start sm:self-center'
          onClick={onOpenImporter}
          data-testid='review-conversions'
        >
          {REVIEW_CONVERSIONS_LABEL}
        </Button>
      )}
    </div>
  );
};

export default ImportedConversionsNote;
